import { Middleware } from '@floating-ui/dom';

/**
 * Middleware to ensure the floating element has the same width as the reference element.
 *
 * This middleware sets the width of the floating element to match the width of the reference element.
 * It is used in the Floating UI library to maintain consistent dimensions between the reference and floating elements.
 */
export const sameWidth: Middleware = {
  name: 'sameWidth',
  fn: state => {
    state.elements.floating.style.width = `${state.rects.reference.width}px`;
    return state;
  },
};
